import { ComingSoon } from './ComingSoon/ComingSoon'

export const RevenueShareScreens = [<ComingSoon />]
